const BaseModel = require('./BaseModel');
const HTTPClient = require('../HTTPClient');

class Email extends BaseModel {
  static basePath = '/api/v1/emails';
  static dataType = 'email';

  constructor(json={}) {
    super(json);

    this.parseChildren(['contact', 'context', 'owner']);
  }

  static create(item, { include = null, path = null } = {}) {
    let params = [];

    if(include != null) {
      if(include instanceof Array) { include = include.join(',') }
      params.push(`include=${include}`);
    }

    const parser = this.prototype.constructor._parseDataItem.bind(this);

    const data = { [item.constructor.dataType]: { ...item } };
    delete data[item.constructor.dataType].attachments;

    const attachments = item.attachments || [];

    return new HTTPClient()
      .post(`${path || this.basePath}?${params.join('&')}`, { data, attachments }, { headers: { 'Content-Type': 'multipart/form-data' }})
      .then(parser);
  }
}

BaseModel.models[Email.dataType] = Email;
module.exports = Email;
